import { axios } from '@/lib/axios';

export const applyPromoCode = async (data: any) =>
    axios.post(`v1/apply-coupon`, data).then((res) => res?.data);
